<div class="hw-box-content">
<div class="hw-header-wrap">
  <div class="row">
    <div class="col-6">JPQL Result</div>
    <div class="col-6 text-right">
      <fn-switch [(ngModel)]="isNative" [name]="'isPictureRequired'" [checkedTemplate]="collapse"
        [unCheckedTemplate]="expand">
      </fn-switch>
      <ng-template #collapse>
        isNative
      </ng-template>
      <ng-template #expand>
        NonNative
      </ng-template>
      <fn-switch [(ngModel)]="isJSONData" class="ms-2" name="isJSONData" [checkedTemplate]="checkedTemplate"
        [unCheckedTemplate]="unCheckedTemplate">
      </fn-switch>
      <ng-template #checkedTemplate>
        <i class="fa fa-pencil"></i> JSON
      </ng-template>
      <ng-template #unCheckedTemplate>
        <i class="fa fa-pencil"></i> Table
      </ng-template>
      <fn-button [type]="'info'" btnClass="btn-sm btn-round width-100 ms-2" [text]="'Parse'"
        (click)="openModal('parse')"></fn-button>
      <fn-button [type]="'info'" btnClass="btn-sm btn-round width-100 ms-2" [text]="'Bulk Queries'"
        (click)="openModal('bulkQueries')"></fn-button>
      <fn-button [type]="'danger'" btnClass="btn-sm btn-round width-100 ms-2" [text]="'Clear Cache'"
        (click)="clearCache()"></fn-button>
    </div>
  </div>
</div>
<div class="hw-content p-15">
  <div class="row mt-15">
    <div class="col-9 offset-3 p-0">
      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-12">
              <textarea placeholder="Type your jpql query..." alta-nice-scroll nice-option="{'horizrailenabled' : true}"
                [(ngModel)]="queryString" rows="3" type="text" class="form-control resize-none"></textarea>
            </div>
          </div>

          <div class="row mt-10">
            <div class="col-3">
              <fn-button [type]="'danger'" btnClass="btn-sm btn-round width-100" class="width-100" text="Execute Query"
                [disabled]="params.isLoadingQuery" (click)="executeQuery(queryString)"></fn-button>
            </div>
            <div class="col-3">
              <fn-button [type]="'info'" btnClass="btn-sm btn-round width-100" class="width-100"
                text="Load Query"></fn-button>
            </div>
            <div class="col-3">
              <fn-button [type]="'success'" btnClass="btn-sm btn-round width-100" class="width-100" text="Download"
                (click)="downloadExcel(queryString)"></fn-button>
            </div>
            <div class="col-3">
              <fn-button [type]="'primary'" btnClass="btn-sm btn-round width-100" class="width-100"
                text="Save Query"></fn-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <h4 class="col-12">
      <span translate class="font-18">Results </span>
      <span class="col-11 pt-5 font-18" *ngIf="jpqlResult.entityArray.length > -1">
        : {{ jpqlResult.recordSize }} record(s) fetched</span>
    </h4>
  </div>
  <div *ngIf="!jpqlResult.isSuccess || jpqlResult.queryType !== 'select'">
    <div class="row resize-none">
      <fn-scrollbar class="col-10 offset-1" [options]="{ scrollbarMinSize: 40, autoHide: false }"
        [position]="'float-left'">
        <pre class="raw-query resize-none {{ jpqlResult.cssClass }}" *ngIf="!jpqlResult.isSuccess">
		  {{ jpqlResult.message }}</pre>
      </fn-scrollbar>

      <fn-scrollbar class="col-10 offset-1" style="overflow-x: hidden; max-height: 250px"
        [options]="{ scrollbarMinSize: 40, autoHide: false }" [position]="'float-left'">
        <pre class="raw-query resize-none {{ jpqlResult.cssClass }}" *ngIf="jpqlResult.isSuccess">
                        {{ jpqlResult.message }}</pre>
      </fn-scrollbar>
    </div>
  </div>
  <div class="col-12 p-0 min-height-300 resize-none" *ngIf="jpqlResult.queryType === 'select' && jpqlResult.isSuccess">
    <div *ngIf="!jpqlResult.entityArray.length">
      <div class="no_data_display m-0">
        {{ "No Data To Display" }}
      </div>
    </div>
    <div *ngIf="jpqlResult.entityArray.length && isJSONData">
      <textarea placeholder=" " alta-nice-scroll nice-option="{'horizrailenabled' : true}" [(ngModel)]="jpqlJSONResult"
        rows="5" type="text" class="form-control resize-none"></textarea>
    </div>
    <div class="row max-height scrolly" *ngIf="jpqlResult.entityArray.length && !isJSONData">
      <fn-scrollbar class="col-12 offset-1 m-0" style="max-height: 250px"
        [options]="{ scrollbarMinSize: 40, autoHide: false }" [position]="'float-left'">
        <table class="table table-bordered table-striped table-hover dataTable scrolly mb-0 fixed-layout">
          <colgroup>
            <col *ngFor="let data of columnArray" width="200px">
          </colgroup>
          <thead>
            <tr>
              <th *ngFor="let data of columnArray">{{ data }}</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let obj of jpqlResult.entityArray">
              <!-- <td *ngFor="let data of columnArray">
								<div class="table-content" >{{obj[data]}}</div>
							</td>  -->

              <td *ngFor="let data of columnArray">
                <!-- <div class="table-content" (click)="openModal(obj[data])">
								  {{ obj[data] | truncate:20 }}
								</div> -->
                <div class="col-5 width-3 mt-8" *ngIf="obj[data] == null; else datapresent"></div>
                <ng-template #datapresent>
                  <div class="table-content" *ngIf="('' + obj[data]).length < 100; else doted">
                    {{ obj[data] }}
                  </div>

                  <ng-template #doted>
                    <div [autoClose]="'outside'" popoverClass="jpql-popover popover-scroll "
                      ngbPopover="{{ obj[data] }}" [placement]="['right', 'left', 'bottom']"
                      #closeAttachment="ngbPopover" container="body" class="text-truncate">
                      {{ (obj[data]) }}
                    </div>
                  </ng-template>
                </ng-template>
              </td>
            </tr>
            <!-- <tr *ngFor="let obj of jpqlResult.entityArray">
							<td *ngFor="let data of columnArray">
							  <div class="table-content">
								<div *ngIf="Array.isArray(obj[data])">
								  <div *ngFor="let item of obj[data]">{{item}}</div>
								</div>
								<div *ngIf="!Array.isArray(obj[data])">
								  {{obj[data]}}
								</div>
							  </div>
							</td>
						  </tr> -->
          </tbody>
        </table>
      </fn-scrollbar>
    </div>
  </div>
  <div class="col-12 p-0 mt-10" *ngIf="!posUtil.emptyString(jpqlResult.rawQuery)">
    <h4 class="font-18">Raw Query :</h4>
    <div class="row">
      <fn-scrollbar class="col-10 offset-1" style="overflow-y: hidden; max-height: 250px"
        [options]="{ scrollbarMinSize: 40, autoHide: false }" [position]="'right'">
        <pre class="raw-query resize-none"> <!--*ngIf="isError"-->
  {{jpqlResult.rawQuery}}</pre>
      </fn-scrollbar>
    </div>
  </div>
  <!-- <fn-pagination [currentPage]="paginationMap.currentPage" *ngIf="jpqlResult.entityArray.length > 0" [totalPage]="paginationMap.totalSize"
    [pageSize]="paginationMap.pageSize" (changePage)="paginzationEvent($event)"></fn-pagination> -->
</div>
</div>
